import client from '@/services/';

const state = () => ({
    all: [],
    one: {},
    allSociete: [],
});

const getters = {
    all: state => state.all,
    one: state => state.one,
    allSociete: state => state.allSociete,
};

const mutations = {
    SET_ALL: (state, obj) => {
        state.all = obj;
    },
    SET_ONE: (state, obj) => {
        state.one = obj;
    },
    SET_ALL_SOCIETE: (state, obj) => {
        state.allSociete = obj;
    },
};

const actions = {
    async getAll(cxt) {
        let data = await client.get('demandesSociete/all');
        cxt.commit("SET_ALL", data);
        return data;
    },
    async getAllP({ commit }, params = {}) {
        const { page = 0, size = 10, sort = '', raisonSociale, chiffreAffaire, montantCotisation, montantFraisDeDossier, cotisationFixeMaintien, cotisationVariableMaintien, state, type, codeRef, sexe, email, sousLibelle, sousCode, imported, treatmentDateAfter, treatmentDateBefore, after, before, dateValidationPaiementAfter, dateValidationPaiementBefore, ifu } = params;
        const queryParams = new URLSearchParams({
            page,
            size,
            sort,
            ...(raisonSociale && { raisonSociale }),
            ...(chiffreAffaire && { chiffreAffaire }),
            ...(montantCotisation && { montantCotisation }),
            ...(montantFraisDeDossier && { montantFraisDeDossier }),
            ...(cotisationFixeMaintien && { cotisationFixeMaintien }),
            ...(cotisationVariableMaintien && { cotisationVariableMaintien }),
            ...(state && { state }),
            ...(type && { type }),
            ...(codeRef && { codeRef }),
            ...(sexe && { sexe }),
            ...(email && { email }),
            ...(sousLibelle && { sousLibelle }),
            ...(sousCode && { sousCode }),
            ...(imported && { imported }),
            ...(treatmentDateAfter && { treatmentDateAfter }),
            ...(treatmentDateBefore && { treatmentDateBefore }),
            ...(after && { after }),
            ...(before && { before }),
            ...(dateValidationPaiementAfter && { dateValidationPaiementAfter }),
            ...(dateValidationPaiementBefore && { dateValidationPaiementBefore }),
            ...(ifu && { ifu }),
        }).toString();
        let { data } = await client.get(`demandesSociete/all/custom?${queryParams}`);
        commit("SET_ALL", data)
        //cxt.commit("SET_ALL", data);
        return data;
    },
    async getAllPMaintient({ commit }, params = {}) {
        const { page = 0, size = 10, sort = '', raisonSociale, chiffreAffaire, montantCotisation, montantFraisDeDossier, cotisationFixeMaintien, cotisationVariableMaintien, state, type, paiementValide, codeRef, sexe, email, sousLibelle, sousCode, imported, treatmentDateAfter, treatmentDateBefore, after, before, dateValidationPaiementAfter, dateValidationPaiementBefore, ifu, progress, traite, prevalidation } = params;
        const queryParams = new URLSearchParams({
            page,
            size,
            sort,
            ...(raisonSociale && { raisonSociale }),
            ...(chiffreAffaire && { chiffreAffaire }),
            ...(montantCotisation && { montantCotisation }),
            ...(montantFraisDeDossier && { montantFraisDeDossier }),
            ...(cotisationFixeMaintien && { cotisationFixeMaintien }),
            ...(cotisationVariableMaintien && { cotisationVariableMaintien }),
            ...(state && { state }),
            ...(type && { type }),
            ...(paiementValide && { paiementValide }),
            ...(codeRef && { codeRef }),
            ...(sexe && { sexe }),
            ...(email && { email }),
            ...(sousLibelle && { sousLibelle }),
            ...(sousCode && { sousCode }),
            ...(imported && { imported }),
            ...(treatmentDateAfter && { treatmentDateAfter }),
            ...(treatmentDateBefore && { treatmentDateBefore }),
            ...(after && { after }),
            ...(before && { before }),
            ...(dateValidationPaiementAfter && { dateValidationPaiementAfter }),
            ...(dateValidationPaiementBefore && { dateValidationPaiementBefore }),
            ...(ifu && { ifu }),
            ...(progress && { progress }),
            ...(traite && { traite }),
            ...(prevalidation && { prevalidation }),
        }).toString();
        let { data } = await client.get(`demandesSociete/maintien?${queryParams}`);
        commit("SET_ALL", data)
        //cxt.commit("SET_ALL", data);
        return data;
    },
    async getOne(cxt, id) { 
        let data  = await client.get('demandesSociete/one/'+id);
        //cxt.commit("SET_ONE", data);
        return data;
    },
    async create(cxt, payload) {
        let { data } = payload.id ? await client.put('demandesSociete/edit/'+payload.id, payload) : await client.post('demandesSociete/add', payload);
        cxt.commit("SET_ONE", data);
        if (payload.id) {
            payload.id = null;
        }
    
        return data;    
    },
    async suiviDemande(cxt, payload) {
        let data = await client.post('demandesSociete/suivi', payload);
        cxt.commit("SET_ONE", data);
        cxt.commit("SET_SELECTED_DEMANDE", data);
        return data;
    },
    async correctionInformation(cxt, payload) {
        let { data } = await client.post('demandesSociete/add/corrigee', payload);
        cxt.commit("SET_ONE", data);
        if (payload.id) {
            payload.id = null;
        }

        return data;
    },
    async del(cxt, id) {
        let { data } = await client.delete('demandesSociete/delete/'+id);
        cxt.commit("SET_ONE", data);
        return data;
    },
    async receptionDemande(cxt, id) {
        let { data } = await client.get('demandesSociete/activate/'+id);
        cxt.commit("SET_ONE", data);
        return data;
    },
    async traitementDemande(cxt, payload) {
        let data = await client.post('demandesSociete/treat', payload);
        cxt.commit("SET_ONE", data);
        return data;
    },
    async recevabilite(cxt, payload) {
        return client.post('demandesSociete/recevabilite', payload);
    },
    async toursRecevabilite(cxt, id) {
        return client.get('demandesSociete/' + id + '/tours-recevabilite');
    },
    async renvoyerMailCorrection(cxt, id) {
        return client.post('demandesSociete/' + id + '/renvoyer-mail-correction');
    },
    async resendCertificatRenouvellement(cxt, demandeId) {
        let { data } = await client.post('demandesSociete/renvoyer-certificat-renouvellement/' + demandeId);
        return data;
    },
    async getAllDemandeConnectee({ commit }, params = {}) {
        const { page = 0, size = 10, sort = '', chiffreAffaire, montantCotisation, montantFraisDeDossier, cotisationFixeMaintien, cotisationVariableMaintien, state, type, codeRef, sexe, email, sousLibelle, sousCode, imported, treatmentDateAfter, treatmentDateBefore, after, before, dateValidationPaiementAfter, dateValidationPaiementBefore, ifu } = params;
        const queryParams = new URLSearchParams({
            page,
            size,
            sort,
            ...(chiffreAffaire && { chiffreAffaire }),
            ...(montantCotisation && { montantCotisation }),
            ...(montantFraisDeDossier && { montantFraisDeDossier }),
            ...(cotisationFixeMaintien && { cotisationFixeMaintien }),
            ...(cotisationVariableMaintien && { cotisationVariableMaintien }),
            ...(state && { state }),
            ...(type && { type }),
            ...(codeRef && { codeRef }),
            ...(sexe && { sexe }),
            ...(email && { email }),
            ...(sousLibelle && { sousLibelle }),
            ...(sousCode && { sousCode }),
            ...(imported && { imported }),
            ...(treatmentDateAfter && { treatmentDateAfter }),
            ...(treatmentDateBefore && { treatmentDateBefore }),
            ...(after && { after }),
            ...(before && { before }),
            ...(dateValidationPaiementAfter && { dateValidationPaiementAfter }),
            ...(dateValidationPaiementBefore && { dateValidationPaiementBefore }),
            ...(ifu && { ifu }),
        }).toString();
        let { data } = await client.get(`/demandesSociete/connected?${queryParams}`);
        commit("SET_ALL", data)
        //cxt.commit("SET_ALL", data);
        return data;
    },
    async renouvellement(cxt, payload) {
        let { data } = await client.post('demandesSociete/add/corrigee', payload);
        //cxt.commit("SET_ONE", data);
        if (payload.id) {
            payload.id = null;
        }

        return data;
    },
    async validationComite(cxt, payload) {
        let { data } = await client.post('/demandesSociete/validate', payload);
        return data;
    },
    async savePrevalidation(cxt, payload) {
        // payload: { demandeId, paiementConforme, formation40hConforme, documents: [...] }
        let { data } = await client.post('demandesSociete/prevalidation', payload);
        return data;
    },
    async exportExcel({ commit }, params = {}) {
        try {
            const { page = 0, size = 10, sort = '', raisonSociale, chiffreAffaire, montantCotisation, montantFraisDeDossier, cotisationFixeMaintien, cotisationVariableMaintien, state, type, codeRef, sexe, email, sousLibelle, sousCode, imported, treatmentDateAfter, treatmentDateBefore, after, before, dateValidationPaiementAfter, dateValidationPaiementBefore, ifu, progress, paiementValide, traite, prevalidation } = params;
            const queryParams = new URLSearchParams();
            if (page !== undefined) queryParams.append('page', page);
            if (size !== undefined) queryParams.append('size', size);
            if (sort) queryParams.append('sort', sort);
            if (raisonSociale) queryParams.append('raisonSociale', raisonSociale);
            if (chiffreAffaire) queryParams.append('chiffreAffaire', chiffreAffaire);
            if (montantCotisation) queryParams.append('montantCotisation', montantCotisation);
            if (montantFraisDeDossier) queryParams.append('montantFraisDeDossier', montantFraisDeDossier);
            if (cotisationFixeMaintien) queryParams.append('cotisationFixeMaintien', cotisationFixeMaintien);
            if (cotisationVariableMaintien) queryParams.append('cotisationVariableMaintien', cotisationVariableMaintien);
            if (state) queryParams.append('state', state);
            if (type) queryParams.append('type', type);
            if (codeRef) queryParams.append('codeRef', codeRef);
            if (sexe) queryParams.append('sexe', sexe);
            if (email) queryParams.append('email', email);
            if (sousLibelle) queryParams.append('sousLibelle', sousLibelle);
            if (sousCode) queryParams.append('sousCode', sousCode);
            if (raisonSociale) queryParams.append('raisonSociale', raisonSociale);
            if (imported) queryParams.append('imported', imported);
            if (treatmentDateAfter) queryParams.append('treatmentDateAfter', treatmentDateAfter);
            if (treatmentDateBefore) queryParams.append('treatmentDateBefore', treatmentDateBefore);
            if (after) queryParams.append('after', after);
            if (before) queryParams.append('before', before);
            if (dateValidationPaiementAfter) queryParams.append('dateValidationPaiementAfter', dateValidationPaiementAfter);
            if (dateValidationPaiementBefore) queryParams.append('dateValidationPaiementBefore', dateValidationPaiementBefore);
            if (ifu) queryParams.append('ifu', ifu);
            if (progress) queryParams.append('progress', progress);
            if (paiementValide) queryParams.append('paiementValide', paiementValide);
            if (traite) queryParams.append('traite', traite);
            if (prevalidation) queryParams.append('prevalidation', prevalidation);

            const response = await client.get(`/demandesSociete/export/excel?${queryParams.toString()}`, {
                responseType: 'blob'
            });
            return response.data;
        } catch (error) {
            console.error('Erreur lors de l\'export Excel (sociétés):', error);
            throw error;
        }
    },
    async exportPrevalidationExcel({ commit }, params = {}) {
        try {
            const { page = 0, size = 10, sort = '', raisonSociale, chiffreAffaire, montantCotisation, montantFraisDeDossier, cotisationFixeMaintien, cotisationVariableMaintien, state, type, codeRef, sexe, email, sousLibelle, sousCode, imported, treatmentDateAfter, treatmentDateBefore, after, before, dateValidationPaiementAfter, dateValidationPaiementBefore, ifu, progress, paiementValide, traite, prevalidation } = params;
            const queryParams = new URLSearchParams({
                page,
                size,
                sort,
                ...(raisonSociale && { raisonSociale }),
                ...(chiffreAffaire && { chiffreAffaire }),
                ...(montantCotisation && { montantCotisation }),
                ...(montantFraisDeDossier && { montantFraisDeDossier }),
                ...(cotisationFixeMaintien && { cotisationFixeMaintien }),
                ...(cotisationVariableMaintien && { cotisationVariableMaintien }),
                ...(state && { state }),
                ...(type && { type }),
                ...(codeRef && { codeRef }),
                ...(sexe && { sexe }),
                ...(email && { email }),
                ...(sousLibelle && { sousLibelle }),
                ...(sousCode && { sousCode }),
                ...(imported && { imported }),
                ...(treatmentDateAfter && { treatmentDateAfter }),
                ...(treatmentDateBefore && { treatmentDateBefore }),
                ...(after && { after }),
                ...(before && { before }),
                ...(dateValidationPaiementAfter && { dateValidationPaiementAfter }),
                ...(dateValidationPaiementBefore && { dateValidationPaiementBefore }),
                ...(ifu && { ifu }),
                ...(progress && { progress }),
                ...(paiementValide && { paiementValide }),
                ...(traite && { traite }),
                ...(prevalidation && { prevalidation }),
            }).toString();

            const response = await client.get(`/demandesSociete/prevalidation/export?${queryParams}`, {
                responseType: 'blob'
            });
            return response.data;
        } catch (error) {
            console.error('Erreur lors de l\'export du rapport de prévalidation (sociétés):', error);
            throw error;
        }
    },
    async statistiqueByType (cxt, type) {
        let data = await client.get('/demandesSociete/stats/' + type);
        return data;
    },
    async addPaiement(cxt, { demandeId, payload }) {
        let { data } = await client.post(`demandesSociete/${demandeId}/paiements`, payload);
        return data;
    },
    async getPaiements(cxt, demandeId) {
        let { data } = await client.get(`demandesSociete/${demandeId}/paiements`);
        return data;
    },
    async getConnectedById(cxt, id) {
        let { data } = await client.get(`/demandesSociete/connected/${id}`);
        return data;
    },
    async initPaiement(cxt, { demandeId, payload }) {
        let { data } = await client.post(`demandesSociete/${demandeId}/paiements/init`, payload);
        return data;
    },
    async confirmPaiement(cxt, { demandeId, payload }) {
        let { data } = await client.post(`demandesSociete/${demandeId}/paiements/confirm`, payload);
        return data;
    },
    async reconcilePaiements(cxt, demandeId) {
        let { data } = await client.post(`demandesSociete/${demandeId}/paiements/reconcile`);
        return data;
    },
    // Actions pour les commentaires du comité
    async ajouterCommentaire(cxt, payload) {
        const { demandeId, commentaire, typeCommentaire } = payload;
        let { data } = await client.post('demandesSociete/commentaire', {
            demandeId,
            commentaire,
            typeCommentaire
        });
        return data;
    },
    // Récupérer tous les commentaires d'une demande société
    async getCommentaires(cxt, demandeSocieteId) {
        let { data } = await client.get(`demandesSociete/${demandeSocieteId}/commentaires`);
        return data;
    },
    // Récupérer un commentaire spécifique par type
    async getCommentaireByType(cxt, { demandeSocieteId, type }) {
        let { data } = await client.get(`demandesSociete/${demandeSocieteId}/commentaires/${type}`);
        return data;
    },
    async checkGerantStatus(cxt) {
        let { data } = await client.get('demandesSociete/check/gerant-status');
        return data;
    },
    async validatePaiementDemande(cxt, { idPaiement, id, dateValidation }) {
        let { data } = await client.put(`demandesSociete/paiement/${idPaiement}/validation-paiement`, {
            id,
            dateValidation
        });
        return data;
    },
    async checkSocieteExists(cxt, { ifu, raisonSociale }) {
        const params = new URLSearchParams();
        if (ifu) params.append('ifu', ifu);
        if (raisonSociale) params.append('raisonSociale', raisonSociale);
        let { data } = await client.get(`demandesSociete/check-exists?${params.toString()}`);
        return data;
    },
    /** Brouillon inscription société : récupérer le brouillon serveur (utilisateur connecté). */
    async getDraft(cxt) {
        try {
            const response = await client.get('demandesSociete/draft');
            if (response.status === 204 || !response.data) return null;
            return response.data;
        } catch (e) {
            return null;
        }
    },
    /** Brouillon inscription société : sauvegarder le brouillon sur le serveur. */
    async saveDraft(cxt, payload) {
        await client.put('demandesSociete/draft', payload);
    },
    /** Brouillon inscription société : supprimer le brouillon serveur (après soumission). */
    async clearDraft(cxt) {
        await client.delete('demandesSociete/draft');
    },
    async attachFichier(cxt, { demandeId, fichierId }) {
        let { data } = await client.post(`demandesSociete/${demandeId}/fichiers/${fichierId}`);
        return data;
    },
};

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
};
